module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/aq-e6c275d0d4e5135fb04baf7ebcaa8e6d.svg";